export default __webpack_public_path__ + "static/Noroutine_Talent_Scouting_Terms_Candidate_EN_03_2020-265b88ddebd48464f72af1306f9eeb17.pdf";